import {mapGetters, mapMutations, mapActions} from 'vuex'

import _ from 'lodash'

import reviewImg from '@/components/review-img/index.vue'

export default {
  name: 'contacts',
  //---components
  components: {
    reviewImg
  },
  //---data
  data () {
    return {
      contactsData: {
        firstName: null,
        lastName: null,
        phone: null,
        email: null,
      },
      isValidContactsForm: true
    }
  },
  //---hooks
  created: function () {
    if (!this.analysis) {
      this.$router.push({name: 'searchProperty'});
    } else {
      if (this.contacts) {
        this.contactsData = _.assign({}, this.contacts);
      } else {
        for (let key in this.URLParams) {
          if (this.contactsData.hasOwnProperty(key)) {
            this.contactsData[key] = this.URLParams[key];
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      URLParams: 'APP/URLParams',
      client: 'CLIENT/client',
      content: 'APP/content',
      analysis: 'ANALYSIS/analysis',
      contacts: 'CONTACTS/contacts',
      userPayment: 'CLIENT/userPayment',
    }),
  },
  //---methods
  methods: {
    ...mapMutations({
      setContacts: 'CONTACTS/CONTACTS_SET',
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
    }),
    ...mapActions({
      setUserPayment: 'CLIENT/CLIENT_USER_PAYMENT_REQUEST_SET',
      updateUserPayment: 'CLIENT/CLIENT_USER_PAYMENT_REQUEST_UPDATE',
    }),

    gotoNextState() {
      this.setContacts(this.contactsData);

      if (this.client.collectAnalysisFee) {
        this.loaderFlag(true);
        this.setUserPayment({
          clientId: this.client.userId,
          payload: {
            firstName: this.contactsData.firstName,
            lastName: this.contactsData.lastName,
            phone: this.contactsData.phone,
            email: this.contactsData.email,
            referrerAffiliateCode: this.client.affiliateCode,
            referrerDomain: window.location.host,
            pin: this.analysis.analysisResults.subjectProperty.pin,
            purchasePrice: this.analysis.purchase.purchasePrice,
            purchaseDate: this.analysis.purchase.purchaseDate,
            analysisFee: this.client.analysisFee,
          }
        }).then(()=>{
          let overpaymentAmount = this.analysis.analysisResults.maxOverpaymentAmount;
          if (overpaymentAmount > 0 && overpaymentAmount <= this.userPayment.analysisFeeBillingThresholdAmount) {
            this.$router.push({name: 'analysis'});
          } else {
            this.updateUserPayment({
              clientId: this.client.userId,
              payload: {
                webUserId: this.userPayment.id,
                analyzedRecordId: this.analysis.analyzedRecordId,
                overpaymentAmount: this.analysis.analysisResults.maxOverpaymentAmount,
              }
            }).then(()=>{
              this.loaderFlag(false);
              this.$router.push({name: 'payment'});
            }).catch( error => {
              this.loaderFlag(false);
              this.$snotify.error(error);
            });
          }
        }).catch( error => {
          this.loaderFlag(false);
          this.$snotify.error(error);
        });
      } else {
        this.$router.push({name: 'analysis'});
      }
    }
  }
}
